// @flow

import React from "react";
import styles from "./searchBox.scss";

const searchIcnUrl = require("../../../assets/images/search_icn.svg");

type Props = {
  onSearchValueChange: Function,
  resetSearchText: boolean,
  onKeyPress?: Function
};

type State = {
  searchVal: string
};

class SearchBox extends React.Component<Props, State> {
  constructor(props: Object) {
    super(props);
    this.state = {
      searchVal: ""
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps && nextProps.resetSearchText !== this.props.resetSearchText) {
      this.setState({
        searchVal: ""
      });
    }
  }

  onChange(val) {
    this.setState(
      {
        searchVal: val
      },
      () => this.props.onSearchValueChange(val)
    );
  }

  handleKeyPress(e) {
    if (this.props.onKeyPress) {
      this.props.onKeyPress(e);
    }
  }

  render() {
    return (
      <div className={`${styles.searchBoxWrapper} search-box-wrapper`}>
        <div className={`${styles.searchIcnWrapper} search-icn-wrapper`}>
          <img
            className={`${styles.searchIcn} search-icn`}
            src={searchIcnUrl}
            alt=""
          />
        </div>
        <input
          className={`${styles.searchBoxInput} search-box-input`}
          placeholder="Search"
          onChange={e => this.onChange(e.target.value)}
          value={this.state.searchVal}
          onKeyPress={e => this.handleKeyPress(e)}
        />
      </div>
    );
  }
}

SearchBox.defaultProps = {
  onKeyPress: null
};

export default SearchBox;



// WEBPACK FOOTER //
// ./app/components/commons/searchBox/searchBox.js